import { useCallback } from 'react';
import { useService } from '~/services/service.base';
import { ServiceFileSaver } from '~/services/service.file.saver';
export const useFileDownload = () => {
    const serviceFileSaver = useService(ServiceFileSaver);
    const downloadImageHandler = useCallback((item) => {
        serviceFileSaver.save(item.fileLink || item.img, item.name);
    }, [serviceFileSaver]);
    const downloadFromServer = useCallback((item) => {
        serviceFileSaver.download('files', [item.id]);
    }, [serviceFileSaver]);
    return { downloadImageHandler, downloadFromServer };
};
